module.exports = __webpack_public_path__ + "img/icon_trading.752ae3f4.svg";